import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Switch, Route } from 'react-router-dom';
import { push } from 'connected-react-router';
// containers
import Login from './screens/Login';
import Activate from './screens/Activate';
import Forgot from './screens/Forgot';
import Reset from './screens/Reset';

/**
 * Auth
 */
 class Auth extends React.PureComponent {
  state = {
    routes: [
      {
        pathname: '/',
        component: Login,
      },
      {
        pathname: '/auth/activate/:activationCode',
        component: Activate,
      },
      {
        pathname: '/auth/reset/:token',
        component: Reset,
      },
      {
        pathname: '/auth/forgot',
        component: Forgot,
      },
    ],
    width: '100%'
  }

  // componentDidMount() {
  //   if (this.props.auth.token) {
  //     this.props.push('/home')
  //   }
  // }

  render() {
    return (
      <>       
        <Switch>
          <div style={{ margin: 20}}>
          {
            this.state.routes.filter((r) => r.component !== '').map((route, i) => (
              <Route key={`route-${i}-${route.pathname}`} exact={true} path={route.pathname} component={route.component} />
            ))
          }
          </div>
        </Switch>
      </>
    )    
  }
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Auth));